import { z } from 'zod';

import { BaseItemSchema } from '../common.js';

export const BaseAssignmentGroupUserSchema = z.object({
  assignmentGroupId: z.uuid(),
  userId: z.uuid(),
});
export type BaseAssignmentGroupUser = z.infer<typeof BaseAssignmentGroupUserSchema>;

export const AssignmentGroupUserSchema = BaseAssignmentGroupUserSchema.extend({
  ...BaseItemSchema.shape,
});
export type AssignmentGroupUser = z.infer<typeof AssignmentGroupUserSchema>;

export const AssignmentGroupUsersParamsSchema = z.object({
  assignmentGroupId: z.uuid(),
  limit: z.coerce.number().positive().optional(),
  offset: z.coerce.number().min(0).optional(),
});
export type AssignmentGroupUsersParams = z.infer<typeof AssignmentGroupUsersParamsSchema>;
